import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const LOGO_URL =
  "https://customer-assets.emergentagent.com/job_premium-frenchies/artifacts/4esp6i90_F2FAF950-A3A1-4810-9E68-EF0F7F8870F6-removebg-preview.png";

export const api = axios.create({ baseURL: API });

export const fileUrl = (path) => {
  if (!path) return null;
  return path.startsWith("http") ? path : `${API}/files/${path}`;
};

export const TICKER_WORDS = [
  "AKC Registered",
  "Health Tested",
  "Stud Service",
  "Puppy Waitlist",
  "OFA Certified",
  "DNA Cleared",
  "Columbus OH",
  "Premium Genetics",
  "Family Raised",
];
